import React, { useContext, useEffect, useState } from 'react';
import Select from 'react-select';
import { ParentContext, CompanyContext, ActivityContext, CarouselContext } from '../../layouts/Dashboard/LayoutDashboard';
import { Pagination, Button, FloatingLabel, Nav } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';

import { ActivityCard } from './ActivityCard';
import { ActivityForm } from './ActivityForm';
import { ActivitySearch } from './ActivitySearch';
import { ActivityCancelAllForm } from './ActivityCancelAllForm';
import { ToggleButton } from '../../utils/Elements/ToggleButton';
import { AlertElement } from '../../utils/Elements/AlertElement';
import { jwtDecode } from 'jwt-decode';
import { toast } from 'react-toastify';
import { useCompanyNavigation } from '../../utils/Hooks/useCompanyNavigation';
import { useDateUtils } from '../../utils/Hooks/useDateUtils';
import '../Pages.css';

// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

export const ActivitiesPage = () => {
  const { formatDate, next } = useDateUtils();
  const api = process.env.REACT_APP_API_ENDPOINT;
  const activitiesPagedEndpoint = `${api}/v1/activity/paged`;
  const activitiesDoneEndpoint = `${api}/v1/activity/done`;
  const userPreferencesEndpoint = `${api}/v1/employees/preferences`;
  //  const employeesEndpoint = `${api}/v1/employees/list`;

  // State management
  const { selectedParentID, setSelectedParentID } = useContext(ParentContext);
  const { selectedCompanyID, selectedCompanyParentID, setSelectedCompanyID, setSelectedCompanyParentID } = useContext(CompanyContext);
  const { searchOptions, 
    setSearchOptions, 
    resetActivityPage, 
    setResetActivityPage,
    activities,
    setActivities,
    resetFilters,
    setResetFilters,
    activityFilters,
    setActivityFilters,
    activityCount,
    setActivityCount
  } = useContext(ActivityContext);
  const { currentPage,
    setCurrentPage,
    totalPages,
    setTotalPages,
    loading,
    setLoading,
    totalRecords,
    setTotalRecords,
    setTotalDisplayed
  } = useContext(CarouselContext);
  const [gridView, setGridView] = useState(false);
  const [activityGridData, setActivityGridData] = useState([]);
  const [width, setWidth] = useState(window.innerWidth);


  const [allCollapsed, setAllCollapsed] = useState(1);
  //const [userCollapsed, setUserCollapsed] = useState(false);
  const [collapseButtonText, setCollapseButtonText] = useState('');

  const [showSearchForm, setSearchForm] = useState(false);

  const [showCancelAllForm, setCancelAllForm] = useState(false);
  const [cancelAllActivity, setCancelAllActivity] = useState(0);

  const [showActivityForm, setActivityForm] = useState(false);
  const [activitySelected, setActivity] = useState({});
  const [followUpActivity, setFollowUpActivity] = useState({});

  //display options dropdown
  const [displayOptions] = useState([
    { value: 20, label: "20 Lines" },
    { value: 50, label: "50 Lines" },
    { value: 100, label: "100 Lines" },
    { value: 200, label: "200 Lines" }
  ]);
  const [displayOption, setDisplayOption] = useState(displayOptions[0]);


  //sort options dropdown
  const [sortOptions] = useState([
    { value: 0, label: "Date Old-New" },
    { value: 1, label: "Date New-Old" },
  ]);
  const [sortOption, setsortOption] = useState(sortOptions[0]);

  const getStoredToken = () => {
    return localStorage.getItem('token');
  };
  const storedToken = getStoredToken();

  const [filterDescription, setFilterDescription] = useState('');
  const [noRecordsMessage, setNoRecordsMessage] = useState('');
  const toCompany = useCompanyNavigation();
  // Functions to handle pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleFirstPage = () => {
    setCurrentPage(1);
  };
  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };
  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };
  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };

  //collapse management
  const collapseAll = () => {
    //if (!userCollapsed) setAllCollapsed(1);
    setAllCollapsed(1);
  };
  const expandAll = () => {
    //if (!userCollapsed) setAllCollapsed(0);
    setAllCollapsed(0);
  };
  const handleToggleCollapse = () => {
    //setUserCollapsed(true);
    setAllCollapsed(1 - allCollapsed);
  };

  // Function to handle the change in cards per page
  const handleDisplayChange = (option) => {
    setDisplayOption(option);
    setCurrentPage(1); // Reset to the first page
    option.value >= 50 ? collapseAll() : expandAll();
  };

  // Function to handle Sort change
  const handleSortChange = (option) => {
    setsortOption(option);
  };

  // Pagination Carousel
  const renderPaginationItems = () => {
    const maxVisibleItems = 5;
    const items = [];
    const startPage = Math.max(currentPage - Math.floor(maxVisibleItems / 2), 1);
    const endPage = Math.min(startPage + maxVisibleItems - 1, totalPages);

    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <Pagination.Item
          key={i} 
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }
    console.log("items", items)
    return items;
  };

  const openEasyNote = () => {
    const url = "https://docs.google.com/forms/d/e/1FAIpQLScbAr0w1mWhUOpsoxt1fBEXEC22aPSkDZ44kAa-eXoYPWMRuQ/viewform";
    window.open(url, '_blank');
  };

  const openAwesomeNotification = () => {
    const url = "https://docs.google.com/forms/d/e/1FAIpQLSc412aPOcxhCy-uTYcLOonlH1Pq3S9Aa20qb-iv8_oCgasgXw/viewform";
    window.open(url, '_blank');
  };

  const openEasyGift = () => {
    const url = "https://docs.google.com/forms/d/e/1FAIpQLSeR5KaFzItDlWPY9Ds--DQSJBSSfNrcSo-Oa6UL3-rCq3Nt5Q/viewform";
    window.open(url, '_blank');
  };
  const openFeedback = () => {
    const url = "https://docs.google.com/forms/d/e/1FAIpQLSddmXQJBxtcMHndW_M6E5oVf82EtcCArYChWtwArf40qZx40Q/viewform";
    window.open(url, '_blank');
  };
  const openSearchForm = () => {
    setSearchForm(true);
  };
  const closeSearchForm = () => {
    setSearchForm(false);
    fetchActivities();
  };
  const openActivityForm = (e, activity, verifyNotes) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    if (verifyNotes){
      activity.checkNotes = true
    }
    // activity.TypeID = 5;
    // activity.typeName = "Follow-Up";
    setActivity(activity);
    setActivityForm(true);
  };
  const closeCancelAllForm = (closeMode) => {
    setCancelAllForm(false);
    if (closeMode === 0) return; //user canceled the process
    setActivityAsDone(cancelAllActivity, closeMode);
  };
  const closeActivity = (e, activity, closeMode, verifyNotes) => {
    //if event comes form drop down button do not prevet event (or dropdown stays open)
    if ((closeMode === 1 || closeMode === 4) && e) { e.preventDefault(); e.stopPropagation(); }
    if (verifyNotes){
      openActivityForm(null, activity, true)
      return
    }
    //closeMode:
    //0: done,
    //1: cancel (will expand to 1=just this one || 2=this one and all future),
    //3: done and add followup
    //4: add followup to a already closed or cancelled activity


    if (closeMode === 1 && activity.FollowUpRecurrenceType !== 0) {
      //cancel of a recurring activity
      // ank user if they want to cancel just this one or all all furute activities as well
      setCancelAllActivity(activity); //remember the activity
      setCancelAllForm(true);

    } else {
      setActivityAsDone(activity, closeMode);
    }

  };

  const getUserPreferences = async () => {
    //TODO:
    const identity = jwtDecode(storedToken);
    try {
      const response = await fetch(userPreferencesEndpoint, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${storedToken}`,
          'Content-Type': 'application/json',
          'EmployeeUID': identity.sub,
        }
      });
      if (response.ok) {
        const data = await response.json();
        setGridView(data.activityGridView);
      } else {
        console.log("error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const setUserPreferences = async (value) => {
    //TODO:
    const identity = jwtDecode(storedToken);
    var payload = { activityGridView: value };
    try {
      const response = await fetch(userPreferencesEndpoint, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${storedToken}`,
          'Content-Type': 'application/json',
          'EmployeeUID': identity.sub,
        },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        //const data = await response.json();
        //console.log(data);
      } else {
        console.log("error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const setActivityAsDone = async (activity, closeMode) => {

    const showErrorMsg = () => {
      toast.error("Failed to close activity", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
        paueOnHover: true,
        theme: 'colored'
      });
    };

    const identity = jwtDecode(storedToken);

    try {
      const response = await fetch(`${activitiesDoneEndpoint}/${activity.ID}?closemode=${closeMode}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${storedToken}`,
          'Content-Type': 'application/json',
          'EmployeeUID': identity.sub,
        }
      });
      if (response.ok) {
        const data = await response.json();
        if (data.success) {

          //if a follow up was requested, open it for editing
          if (data.followupActivity) {
            openActivityForm(null, data.followupActivity);
          }
          fetchActivities();
        } else {
          showErrorMsg();
        }
      } else {
        showErrorMsg();
      }
    } catch (error) {
      showErrorMsg();
    }

  };

  const setFollowUp = (id) => {
    console.log(id);
    console.log(activities);
    const followUpActivity = activities.find(obj => obj.ID === id);
    followUpActivity.ID = -2;
    openActivityForm(null, followUpActivity);
  };

  const closeActivityForm = () => {
    setActivityForm(false);
    fetchActivities(); //refresh page
  };
  const fetchActivities = async () => {
    if (storedToken) {

      setLoading(true);

      const identity = jwtDecode(storedToken);

      let af = {};
      let sort = sortOption.value;
      if (searchOptions && searchOptions.mode) {
        af = setSearchFilters();
        sort = 1;
        setsortOption(sortOptions[1])
      } else {
        af = activityFilters;
      }
      const payload = {
        EmployeeUID: identity.sub,
        SelectedParentID: selectedCompanyParentID ? selectedCompanyParentID : selectedParentID,
        SelectedCompanyID: selectedCompanyID,
        PageNo: currentPage,
        PageSize: displayOption.value,
        SortBy: 0,
        SortOrder: sort,
        Filter_ParentID: selectedCompanyParentID ? selectedCompanyParentID : selectedParentID,
        Filter_CompanyID: selectedCompanyID,
        Filter_ActivityForID: af.activityFor,
        Filter_ContactID: af.contactId,
        Filter_SalesRepID: af.salesRepId,
        Filter_ActivityType: af.activityType,
        Filter_Recurrence: af.recurrence,
        Filter_Status: af.status,
        Filter_DateRange: af.dateRange,
        Filter_DateType: af.dateType,
        Filter_DateStart: af.dateRangeStart,
        Filter_DateEnd: af.dateRangeEnd,
        Filter_Total: af.filterTotal,
        Filter_Apply: af.applyFilter,
        Filter_PricingPlanID: af.pricingPlanId
      };

      try {
        const response = await fetch(activitiesPagedEndpoint, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
        if (response.ok) {
          const data = await response.json();
          console.log("Page Render Payload:", payload);
          console.log("Page Render Data:", data);
          //buildActivityGridData(data);
          setActivities(data.Activities);
          setTotalRecords(data.TotalCount);
          console.log("searchOptions", searchOptions)
          console.log("Payload: ",payload)
          console.log("Total Activities", data.TotalCount)
          console.log("resetFilters", resetFilters)
          setActivityCount(data.TotalCount);
          console.log("data.Activities.length 1", data.Activities.length)
          setTotalDisplayed(Math.min(activityCount, displayOption.value));
          setTotalPages(Math.ceil(data.TotalCount / displayOption.value));
          setLoading(false);
        } else {
          setLoading(false);
          //console.error('Failed to fetch activities');
          toast.error("Failed to load activities", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
            paueOnHover: true,
            theme: 'colored'
          });

        }
      } catch (error) {
        setLoading(false);
        //console.error('Failed to fetch activities', error);
        toast.error("Failed to load activities", {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
          paueOnHover: true,
          theme: 'colored'
        });
      }

    } else {
      setActivities([]);
      setTotalRecords(0);
      console.log("data.Activities.length 2", activityCount)
      setTotalDisplayed(Math.min(activityCount, displayOption.value));
      setTotalPages(0);
    }
  };
  const buildNoRecordsMsg = () => {
    var msg;

    if (loading) {
      msg = "Loading...please wait";
    } else if (!activityFilters.applyFilter || activityFilters.filterTotal === 0) {

      if (selectedParentID !== 0 || selectedCompanyID !== 0) {
        msg = "No Upcoming Activities with the selected Company/Parent. <link>Remove Company/Parent Filter</link> or use Search to access more Activities.";
      } else {
        msg = "No Upcoming Activities. Use Search to access more Activities.";
      }

    } else {
      msg = "No Activities found that match the applied filters. <link>Remove Filters</link>";
    }
    setNoRecordsMessage(msg);

  };
  const buildFilterMsg = () => {
    var msg;

    let count = activityFilters.applyFilter ? activityFilters.filterTotal : 0;

    if (loading) {
      msg = "Loading...please wait";
    } else {
      msg = 'displaying '
        + (currentPage === 1 ? 'first' : currentPage === totalPages ? 'last' : 'next')
        + ' ' + Math.min(activityCount, displayOption.value) + ' Activities of ' + totalRecords + (count !== 0 ? ' found ' : ' upcoming') + " | " + count + ' filters applied.';
    }
    setFilterDescription(msg);
  };

  const clearFilters = () => {

    //const identity = jwtDecode(storedToken);

    activityFilters.parentId = selectedCompanyParentID ? selectedCompanyParentID : selectedParentID;
    activityFilters.companyId = selectedCompanyID;

    //activityFilters.activityFor = (allEmployees.find(x => x.data === identity.sub.toUpperCase())).value;
    activityFilters.activityFor = -1; //-1 indicates the logged in user, 0 indicates any user (wildcard)
    activityFilters.contactId = 0;
    activityFilters.contactName = "";
    activityFilters.salesRepId = 0;
    activityFilters.activityType = 0;
    activityFilters.recurrence = - 1;
    activityFilters.status = 0;
    activityFilters.dateType = 0;
    activityFilters.dateRange = 0;
    activityFilters.dateRangeStart = formatDate(new Date('01/01/1980'));
    activityFilters.dateRangeEnd = next(7);
    activityFilters.pricingPlanId = 0;
    activityFilters.filterTotal = 1;
    activityFilters.applyFilter = false;
    setActivityFilters(activityFilters);
  };
  
  const noRecordsClickHandler = () => {

    if (noRecordsMessage.indexOf("<link>Remove Filters</link>") !== -1) {
      handleResetFilters();
    } else if (noRecordsMessage.indexOf("<link>Remove Company/Parent Filter</link>") !== -1) {
      resetParentCompany();
    }

  };

  const handleResetFilters = () => {
    console.log("handleResetFilters");
    clearFilters();
    setCurrentPage(1);
    fetchActivities();
  };

  const resetParentCompany = () => {
    setSelectedParentID(0); //this will force reset of main parent and compnay dropdowns
    setSelectedCompanyID(0);
    setSelectedCompanyParentID(0);
  };

  const setSearchFilters = () => {
    let af = {};
    if (searchOptions && searchOptions.mode) {
      //Set search filters
      if (searchOptions.mode === 1) {
        //Contact page redirect

        af.parentId = 0; //selectedCompanyParentID ? selectedCompanyParentID : selectedParentID;
        af.companyId = 0; // selectedCompanyID;
        af.activityFor = 0; //-1 indicates the logged in user, 0 indicates any user (wildcard)
        af.contactId = searchOptions.value;
        af.contactName = searchOptions.data;
        af.salesRepId = 0;
        af.activityType = 0;
        af.recurrence = - 1;
        af.status = 4; //4=Todo and Done
        af.dateType = 0;
        af.dateRange = 7; //7=all dates
        af.dateRangeStart = formatDate(new Date('01/01/1980'));
        af.dateRangeEnd = next(7);
        af.filterTotal = 4;
        af.applyFilter = true;
        af.pricingPlanId = 0;
        setActivityFilters(af);

      } else if (searchOptions.mode === 2) {
        //company page redirect

        af.parentId = 0; // selectedCompanyParentID ? selectedCompanyParentID : selectedParentID;
        af.companyId = searchOptions.value;
        af.activityFor = 0; //-1 indicates the logged in user, 0 indicates any user (wildcard)
        af.contactId = 0;
        af.contactName = "";
        af.salesRepId = 0;
        af.activityType = 0;
        af.recurrence = - 1;
        af.status = 4; //4=Todo and Done;
        af.dateType = 0;
        af.dateRange = 7; //7=all dates
        af.dateRangeStart = formatDate(new Date('01/01/1980'));
        af.dateRangeEnd = next(7);
        af.filterTotal = 3;
        af.applyFilter = true;
        af.pricingPlanId = 0;
        setActivityFilters(af);
      }
      //clear search mode
      setSearchOptions({ mode: 0, value: 0, data: "" });
    }
    return af;
  };

  const Telto = ({ phone, children }) => {
    return <a className="telto-link" href={`telto:${phone}`}>{children}</a>;
  };

  const Mailto = ({ email, children }) => {
    return <a className="mailto-link" href={`mailto:${email}`}>{children}</a>;
  };


  const colHeaderFormatter = (col, colNdx, components) => {

    var header = "";

    switch (colNdx) {

      case 0:
        header = <><div><div>&nbsp;</div><div>Actions</div><div>&nbsp;</div></div></>;
        break;

      case 1:
        header = <>
          <div>
            <div>&nbsp;</div>
            <div>Status</div>
            <div>Date</div>
            <div>&nbsp;</div>
          </div>
        </>;
        break;

      case 2:
        header = <>
          <div>
            <div>Company</div>
            <div>Address</div>
          </div>
        </>;
        break;


      case 3:
        header = <>
          <div>
            <div>Contact</div>
            <div>Title</div>
          </div>
        </>;
        break;
      case 4:

        header = <>
          <div>
            <div>Email</div>
            <div>P: Phone</div>
            <div>C: Cell</div>
          </div>
        </>;
        break;

      case 5:
        header = <>
          <div>
            <div>Activity Type</div>
            <div>Recurrence</div>
          </div>
        </>
        break;

      case 6:
        header = <>
          <div>
            <div>Notes</div>
          </div>
        </>
        break;

      case 7:
        header = <>
          <div>
            <div>A: Assigned To</div>
            <div>C: Creator</div>
            <div>S: Sales Rep</div>
          </div>
        </>
        break;
      default:
    }

    //header = "dummy header";

    return header;
  };

  const colLinksFormatter = (cell, row, rowNdx, xtra) => {
    var data;
    if (row.IsAssociated) {

      if (row.Status === 'OPEN') {
        data = <>
          <div>
            <div style={{ textAlign: "center" }} title="Mark Activity as Done"><Button className="activity-grid-link" onClick={e => { closeActivity(null, row, 0, true) }}>Done</Button></div>
            {/* <div style={{ textAlign: "center" }} title="Mark as Done & Add Follow-Up"><Button className="activity-grid-link" onClick={e => { closeActivity(null, row, 3, true) }}>Done + F/U</Button></div> */}
            <div style={{ textAlign: "center" }} title="Cancel Activity"><Button className="activity-grid-link" onClick={e => { closeActivity(null, row, 1, true) }}>Cancel</Button></div >
            <div style={{ textAlign: "center" }} title="Open for Edit"><Button className="activity-grid-link" onClick={e => { openActivityForm(null, row) }}>Edit</Button></div >
          </div >
        </>
      } else {
        data = <>
          <div>
            <Button className="activity-grid-link" onClick={e => { setFollowUp(row.ID) }}>Add Follow-Up</Button>
          </div >
        </>
      }

    } else {
      data = "";
    }

    return data;
  };

  const colStatusFormatter = (cell, row, rowNdx, xtra) => {
    var data;

    var bgcolor = row.Status === 'OPEN' ? row.DueInDays < 0 ? '#ff9999' : row.DueInDays === 0 ? '#ffd966' : null : '#d3d3d3';
    var status = cell === 'OPEN' ? 'TO DO' : cell === 'CLOSED' ? 'DONE' : cell;

    //data = <span style={{ textAlign: "center", display: 'block', width: "95%", overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipsis' }}>{cell}</span>
    data = <>
    <div style={{ backgroundColor: bgcolor, textAlign: "center" }}>{status}</div>
    <div style={{ textAlign: "center" }}>{row.StartDateFormatted}</div>
    </>;
    return data;
  }

  const colCompanyFormatter = (cell, row, rowNdx, xtra) => {
    //company, addressline1, addressline2, addressCSZ
    var data = <></>


    data = <>
      <div style={{ textAlign: "left" }}>
        <div><a className='company-link' href='#' onClick={() => toCompany(row.CompanyID)}>{row.CompanyName}</a></div>
        <div>{row.CompanyAddressLine1}</div>
        {row.CompanyAddressLine2 ?
          <div>{row.CompanyAddressLine2}</div>
          : null }
        <div>{row.CompanyAddressCSZ}</div>
      </div>
    </>;
    //data = cell;
    return data;
  };

  const colContactFormatter = (cell, row, rowNdx, xtra) => {
    //contact, title
    var data = <></>
    data = <>
      <div style={{ textAlign: "left" }}>
        <div>{row.IndividualName}</div>
        <div>{row.IndividualTitle}</div>
      </div>
    </>;
    //data = cell;
    return data;
  };

  const colEmailFormatter = (cell, row, rowNdx, xtra) => {
    //email, phone, cell
    var data = <></>
    data = <>
      <div>
        <div style={{ textAlign: "left" }} title={row.IndividualEmail}>
          <span style={{ display: 'block', width: "95%", overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipsis' }}>
            <Mailto email={row.IndividualEmail}>{row.IndividualEmail}</Mailto>
          </span>
        </div>

        <div style={{ textAlign: "left" }} title={row.IndividualPhone}>
          <span style={{ display: 'block', width: "95%", overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipsis' }}>
            P: <Telto phone={row.IndividualPhone}>{row.IndividualPhone}</Telto>
          </span>
        </div>

        <div style={{ textAlign: "left" }} title={row.IndividualCell}>
          <span style={{ display: 'block', width: "95%", overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipsis' }}>
            C: <Telto phone={cell[2]}>{row.IndividualCell}</Telto>
          </span>
        </div>
      </div>
    </>;
    //data = cell;
    return data;
  };

  const colActivityTypeFormatter = (cell, row, rowNdx, xtra) => {
    //type, recurrence
    var data = <></>
    data = <>
      <div>
        <div style={{ textAlign: "center" }} title={row.TypeName}>
          <span style={{ display: 'block', width: "95%", overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipsis' }}>
            {row.TypeName}
          </span>
        </div>
        <div style={{ textAlign: "center" }} title={row.FollowUpRecurrenceText}>
          <span style={{ display: 'block', width: "95%", overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipsis' }}>
          {row.FollowUpRecurrenceText}
          </span>
        </div>
      </div>
    </>;
    //data = cell;
    return data;
  };

  const colAssignedToFormatter = (cell, row, rowNdx, xtra) => {
    //AssignedTo, CreatedBy, SaleRep
    var data = <></>
    data = <>
      <div>
        <div style={{ textAlign: "left" }} title={row.ActivityForName}>
          <span style={{ display: 'block', width: "95%", overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipsis' }}>
            A: {row.ActivityForName}
          </span>
        </div>
        <div style={{ textAlign: "left" }} title={row.ActivityCreatorName}>
          <span style={{ display: 'block', width: "95%", overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipsis' }}>
            C: {row.ActivityCreatorName}
          </span>
        </div>
        <div style={{ textAlign: "left" }} title={row.CompanySalesRepName}>
          <span style={{ display: 'block', width: "95%", overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipsis' }}>
            S: {row.CompanySalesRepName}
          </span>
        </div>
      </div>
    </>;
    //data = cell;
    return data;
  };


  const colOverflowEllipsisFormatter = (cell, row, rowNdx, xtra) => {
    //used for simple one line data columns to prevent cell overflow with ellipsis
    var data;
    data = <span style={{ display: 'block', width: "95%", overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipsis' }}>{cell}</span>
    return data;
  };


  const colOverflowWrapFormatter = (cell, row, rowNdx, xtra) => {
    //used for simple one line data columns to prevent cell overflow with wrap
    var data;
    data = <span style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{cell}</span>
    return data;
  };

  //const altRowColor = (row, rowIdx) => {
  //  return { backgroundColor: rowIdx % 2 === 0 ? '#FF0000' : '#0000FF' };
  //};


  const columns = [{
    dataField: 'actions',
    text: "",
    headerStyle: () => { return { backgroundColor: "#0da9ef", color: "white", width: "140px" } },
    headerAlign: 'center',
    headerFormatter: colHeaderFormatter,
    formatter: colLinksFormatter,
  }, {
    dataField: 'Status',
    text: "",
    headerStyle: () => { return { backgroundColor: "#0da9ef", color: "white", width: "150px" } },
    headerAlign: 'center',
    headerFormatter: colHeaderFormatter,
    formatter: colStatusFormatter,
  }, {
    dataField: 'CompanyName',
    text: "",
    headerStyle: () => { return { backgroundColor: "#0da9ef", color: "white", width: "275px" } },
    headerAlign: 'center',
    headerFormatter: colHeaderFormatter,
    formatter: colCompanyFormatter,
  }, {
    dataField: 'IndividualName',
    text: "",
    headerStyle: () => { return { backgroundColor: "#0da9ef", color: "white", width: "225px" } },
    headerAlign: 'center',
    headerFormatter: colHeaderFormatter,
    formatter: colContactFormatter,
  }, {
    dataField: 'IndividualEmail',
    text: "",
    headerStyle: () => { return { backgroundColor: "#0da9ef", color: "white", width: "225px" } },
    headerAlign: 'center',
    headerFormatter: colHeaderFormatter,
    formatter: colEmailFormatter,
  }, {
    dataField: 'TypeName',
    text: "",
    headerStyle: () => { return { backgroundColor: "#0da9ef", color: "white", width: "150px" } },
    headerAlign: 'center',
    headerFormatter: colHeaderFormatter,
    formatter: colActivityTypeFormatter,
  }, {
    dataField: 'ActivityComments',
    text: "",
    headerStyle: () => { return { backgroundColor: "#0da9ef", color: "white", width: "250px" } },
    headerAlign: 'center',
    headerFormatter: colHeaderFormatter,
    formatter: colOverflowWrapFormatter,
  }, {
    dataField: 'ActivityForName',
    text: "",
    headerStyle: () => { return { backgroundColor: "#0da9ef", color: "white", width: "200px" } },
    headerAlign: 'center',
    headerFormatter: colHeaderFormatter,
    formatter: colAssignedToFormatter,
  }];

  const handleGridToggle = (e) => {
    // setUserPreferences(!gridView);
    setGridView(!gridView);
  };

  const handleGridAbove1000 = () => {
    setGridView(true);
  }

  const handleGridBelow1000 = () => {
    setGridView(false);
  }

  const getInitialGrid = async () => {
    const currentWidth = window.innerWidth;
    setWidth(currentWidth);
    if (currentWidth >= 1000) {
      handleGridAbove1000();
    } else if (currentWidth < 1000) {
      handleGridBelow1000();
    }
  }

  //collapse management
  useEffect(() => {
    setCollapseButtonText(allCollapsed ? 'Expand All' : 'Collapse All');
  }, [allCollapsed]);

  //filter message
  useEffect(() => {
    buildFilterMsg();
  }, [loading, currentPage, totalPages, totalRecords, activityFilters]);

  useEffect(() => {
    if (followUpActivity && followUpActivity.ID === -2) {
      openActivityForm(null, followUpActivity);
    }
  }, [followUpActivity]);

  //no records message
  useEffect(() => {
    buildNoRecordsMsg();
  }, [selectedParentID, selectedCompanyID, loading]);

  useEffect(() => {
    clearFilters();
  }, [selectedParentID, selectedCompanyID]);

  //load activity cards
  useEffect(() => {
    fetchActivities();
  }, [selectedParentID, selectedCompanyID, currentPage, sortOption, displayOption]);

  //load user preferences
  useEffect(() => {
    // getUserPreferences();
    getInitialGrid();
  }, [storedToken]);

  useEffect(() => {
    if (resetActivityPage === true){
      setSearchOptions({mode: 0, value: 0, data: ""})
      console.log("resetting activities page")
      fetchActivities();
      setResetActivityPage(false);
    }
  }, [resetActivityPage]);

  useEffect(() => {
    let prevWidth = window.innerWidth;
    const handleResize = () => {
      const currentWidth = window.innerWidth;
      setWidth(currentWidth);
      if (currentWidth >= 1000 && prevWidth < 1000) {
        handleGridAbove1000();
      } else if (currentWidth < 1000 && prevWidth >= 1000) {
        handleGridBelow1000();
      }
      prevWidth = currentWidth;
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Add new useEffect to handle filter reset
  useEffect(() => {
    if (resetFilters) {
      handleResetFilters();
      setResetFilters(false); // Reset the trigger
    }
  }, [resetFilters]);

  return (
    <>
      <div className="sticky-top">

        {/*<Nav className='navbar navbar-expand-lg nav-card-actions'>*/}
        {/*  <div className='container'>*/}
        {/*    <div className='displaying-wrapper'>*/}
        {/*      <div className='navbar-text page-title'>Activities</div>*/}
        {/*      <div className='navbar-text filter-description'>*/}
        {/*        {filterDescription}*/}
        {/*        {activityFilters.applyFilter && activityFilters.filterTotal !== 0  ?*/}
        {/*          <Button className="remove-filter-link" onClick={resetFilters}>remove filters</Button>*/}
        {/*          : null}*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*    <div className='row activity-button-row'>*/}
        {/*      <button className='activity-send col-auto btn btn-outline-success btn-easy-button' onClick={openEasyNote}>*/}
        {/*        <div className='hidden-sm-down'>Send Easy-Button Note</div>*/}
        {/*      </button>*/}
        {/*      <button className='activity-send col-auto btn btn-outline-success btn-easy-button' onClick={openEasyGift}>*/}
        {/*        <div className='hidden-sm-down'>Send Easy-Button Gift</div>*/}
        {/*      </button>*/}
        {/*      <button className='activity-send col-auto btn btn-add-contact'>*/}
        {/*        <div className='hidden-sm-down' onClick={openActivityForm}>Add Activity</div>*/}
        {/*      </button>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</Nav>*/}

        <Nav className='navbar navbar-expand-lg nav-card-actions'>
          <div className='container'>
            <div className='row nav-row page-action-row'>
              <div className='col-sm-12 col-md-8'>
                <div className='displaying-wrapper row'>
                  <div className='col-sm-12 col-md-3 page-title-wrapper'>
                    <div className='navbar-text page-title'>Activities</div>
                  </div>
                  <div className='col-sm-12 col-md-9'>
                    <div className='navbar-text filter-description'>
                      {filterDescription}
                      {activityFilters.applyFilter && activityFilters.filterTotal !== 0 ?
                        <Button className="remove-filter-link" onClick={handleResetFilters}>remove filters</Button>
                        : null}
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-sm-12 col-md-4 col-12 align-self-end align-prospect'>
                <div className='d-flex mobile-button-flow'>
                  <button className='btn btn-outline-info btn-add-feedback-activities' onClick={openFeedback}>
                    <div className='hidden-sm-down'>Feedback</div>
                  </button>
                  <button className='activity-send col-auto btn btn-add-contact'>
                    <div className='hidden-sm-down' onClick={openActivityForm}>Add Activity</div>
                  </button>
                </div>
              </div>
              <div className='col-xs-12 col-sm-12 col-md-12 align-self-end align-prospect activity-action'>
                <div className='d-flex'>
                  <button className='activity-send col-auto btn btn-outline-success btn-easy-button' onClick={openEasyNote}>
                  <div className='hidden-sm-down'>Send Note</div>
                  </button>
                  <button className='activity-send col-auto btn btn-outline-success btn-easy-button' onClick={openEasyGift}>
                    <div className='hidden-sm-down'>Send Gift</div>
                  </button>
                  <button className='activity-send col-auto btn btn-outline-success btn-easy-button' onClick={openAwesomeNotification}>
                    <div className='hidden-sm-down'>Send Awesome Nomination</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Nav>

        <Nav className='navbar navbar-expand-lg nav-card-dropdowns justify-content-end'>
          <div className='container'>
            <div className='row filter-grid-container'>

              <div className='col-md-4'>
                <div className='d-flex'>
                  <Button className="search-button" variant="primary" onClick={openSearchForm}>Search...</Button>
                  <div className='grid-toggle-wrapper'>
                    <label style={{ paddingRight: "10px" }}>
                      Grid View:
                    </label>
                    <ToggleButton 
                      onToggle={handleGridToggle}
                      isToggled={gridView}
                    />
                  </div>
                </div>
              </div>

              <div className='p-0-desktop col-12 col-sm-12 col-md-8 align-self-end'>
                <div className='row justify-content-end'>
                  <div className='filter-item-collapse col-12 col-md-auto'>
                    <div className='collapse-all-inner'>
                      <Button className='btn-collapse' variant="primary" onClick={handleToggleCollapse}>
                        {collapseButtonText}<i className={collapseButtonText === 'Collapse All' ? "i-collapse fa fa-compress" : "i-collapse fa fa-expand"} aria-hidden="true" />
                      </Button>
                    </div>
                  </div>
                  <div className='p-0-desktop filter-item-display col-12 col-md-auto'>
                    <FloatingLabel className="floating-select" label={`Display/Page:`}>
                      <Select
                        className="filter-activity-display"
                        classNamePrefix="select"
                        options={displayOptions}
                        value={displayOption}
                        onChange={handleDisplayChange}
                      />
                    </FloatingLabel>
                  </div>
                  <div className='p-0-desktop filter-item-sort col-12 col-md-auto'>
                    <FloatingLabel className="floating-select" label={`Sort by:`}>
                      <Select
                        className="filter-activity-sort"
                        classNamePrefix="select"
                        options={sortOptions}
                        value={sortOption}
                        onChange={handleSortChange}
                      />
                    </FloatingLabel>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Nav>



        {activities && totalRecords > displayOption.value ? (
          <div className='navbar navbar-expand-lg nav-card-pagination'>
            <div className='pagination-wrapper'>
              <Pagination>
                <Pagination.First onClick={handleFirstPage}>
                  <i className="fa fa-angle-double-left pagination-icon-left" aria-hidden="true" />
                  First
                </Pagination.First>
                <Pagination.Prev onClick={handlePrevPage}>
                  <i className="fa fa-angle-left pagination-icon-left" aria-hidden="true" />
                  Previous
                </Pagination.Prev>
                {renderPaginationItems()}
                <Pagination.Next onClick={handleNextPage}>
                  Next
                  <i className="fa fa-angle-right pagination-icon-right" aria-hidden="true" />
                </Pagination.Next>
                <Pagination.Last onClick={handleLastPage}>
                  Last
                  <i className="fa fa-angle-double-right pagination-icon-right" aria-hidden="true" />
                </Pagination.Last>
              </Pagination>
            </div>
          </div>
        ) : (
          <div className="pagination-grid-empty"></div>
        )}

      </div>

      <ActivityCancelAllForm showModal={showCancelAllForm} closeModal={closeCancelAllForm}></ActivityCancelAllForm>
      <ActivityForm showModal={showActivityForm} closeModal={closeActivityForm} activityInfo={activitySelected} setFollowUp={setFollowUpActivity}></ActivityForm>
      <ActivitySearch showModal={showSearchForm} closeModal={closeSearchForm} activityFilters={activityFilters} setActivityFilters={setActivityFilters}></ActivitySearch>

      {activities && activities.length > 0 ?
        <>
        <div className="gridview-wrapper">
          <div className={gridView ? "gridview-container gridview" : "container"}>
            {gridView ?
              <BootstrapTable className="activity-grid" keyField='ID' data={activities} columns={columns} striped/>
              :
              <div className={loading ? 'cards-loading' : 'cards-loaded'}>
                {activities.map((activity, index) => (
                  <ActivityCard
                    key={index}
                    activity={activity}
                    eventKey={String(allCollapsed)}
                    loading={loading}
                    editActivity={(e, value) => openActivityForm(e, value)}
                    closeActivity={(e, value, mode) => closeActivity(e, value, mode, true)}
                  />
                ))}
              </div>
            }
          </div>
        </div>
        </>
        :
        <div className='container'>
          <AlertElement textBody={noRecordsMessage} clickHandler={noRecordsClickHandler} />
        </div>
      }
    </>
  );
};